// ©2024 Austin App House. All rights reserved.
import React from 'react';
// eslint-disable-next-line import/no-cycle
import Content from '../../components/manageCompanies/Content';

const ManageCompanies = ({ mainContainer }) => (
  <div className="subpage-wrap subpage-wrap--admin">
    <div className="subpage-header">
      <h1 className="subpage-title">Manage Companies</h1>
    </div>
    <Content />
  </div>
);

export default ManageCompanies;
